import React, { useState } from 'react';
import { ChevronDown, Calculator } from 'lucide-react';
import { navLinks } from '../data/mock';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-[72px]">
        {/* Logo */}
        <div className="flex items-center gap-5">
          <a href="/" className="flex items-center">
            <img
              src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/69e0a8442fde5f7cc3b2d3c6_newlogoxeno-blue11.png"
              alt="Xeno Logo"
              className="h-8"
            />
          </a>
          <a
            href="#"
            className="hidden md:flex items-center border border-gray-300 rounded-full px-4 py-1.5 text-sm font-medium text-gray-700 hover:border-blue-500 hover:text-blue-600 transition-colors"
          >
            Agentic Marketing Platform
          </a>
        </div>

        {/* Navigation Links */}
        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <div
              key={link.label}
              className="relative"
              onMouseEnter={() => setOpenDropdown(link.label)}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <button
                className="flex items-center gap-1 px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors rounded-lg"
              >
                {link.label}
                {link.hasDropdown && (
                  <ChevronDown className="w-4 h-4" />
                )}
              </button>

              <AnimatePresence>
                {link.hasDropdown && openDropdown === link.label && (
                  <motion.div
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 8 }}
                    transition={{ duration: 0.15 }}
                    className="absolute top-full left-0 mt-1 bg-white rounded-xl shadow-lg border border-gray-100 py-2 min-w-[200px] z-[100]"
                  >
                    {link.items.map((item) => (
                      <a
                        key={item.label}
                        href={item.href}
                        className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                      >
                        {item.label}
                      </a>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        {/* Right side buttons */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/roi-calculator')}
            className={`hidden md:flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${
              location.pathname === '/roi-calculator'
                ? 'bg-[#e2f2ff] text-[#0071fe]'
                : 'text-[#0071fe] border border-[#0071fe] hover:bg-[#e2f2ff]'
            }`}
          >
            <Calculator className="w-4 h-4" />
            ROI Calculator
          </button>
          <a
            href="#"
            className="hidden md:flex items-center px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:border-gray-400 transition-colors"
          >
            Sign in
          </a>
          <a
            href="#"
            className="flex items-center px-5 py-2.5 text-sm font-semibold text-white bg-[#2563EB] rounded-lg hover:bg-[#1d4ed8] transition-colors"
          >
            Get started
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
